import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { PermissionsService } from '~app/services/permissions.service';
import { UserService } from '~app/services/user.service';


export const AuthGuard: CanActivateFn = () =>
	inject(PermissionsService).canActivate(inject(UserService), inject(Router));
